import React from 'react';
import {Atom} from '@packages/systems/wfdl';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';
import {EvaluatedNodeData, getChildren} from '@packages/utilities/data-utils';

const ShippingBlockContent = Atom.createRender(
  ({attributes, classes, data, generateAttributes, renderChild}) => (
    <fieldset {...generateAttributes(attributes, classes)}>
      {getChildren(data).map((child: EvaluatedNodeData) => renderChild(child))}
    </fieldset>
  )
);

const config = createIntegratedAtom({
  displayName: 'Block Content',
  showEmpty: true,
  render: ShippingBlockContent,
  fields: {children: TListOfElement},
});

export default config;
